import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import LoginPage from '../user/LoginPage';
import RegistrationPage from '../user/RegistrationPage';
import ForgottenPage from '../user/ForgottenPage';
import PasswordResetPage from '../user/PasswordResetPage';
import ActivateAccountPage from '../user/ActivateAccountPage';
import PageNotFound from '../PageNotFound';
import ResourceNotAvailable from '../ResourceNotAvailable';
import LoadingPage from "../common/LoadingPage";
import { checkLogin } from '../../redux/actions/authActions';
import './Layout.css';

function AuthLayout(
    {
        user,
        checkLogin,
        history
    }
) {

    const [processing, setProcessing] = useState(true);

    useEffect(() => {
        if (!user || !user.id) {
            setProcessing(true);
            checkLogin()
                .then((result) => {
                    if (result.isAuthenticated) {
                        history.push(`/dashboard`);
                    }
                    setProcessing(false);

                })
        }
        else {
            history.push(`/dashboard`);
        }
    }, [])


    return (
        processing ? <LoadingPage /> :
            <React.Fragment>
                <div className="auth-back-fill"></div>
                <div className="h-100 auth-background justify-content-center">
                    <div className="auth-container my-auto col-12 col-md-8 col-lg-6">
                        <div className="auth-logo">
                            <Link to="/" className="">
                                <img className="siteLogo" src="/resources/images/logo.png" alt="JustGoRide" />
                            </Link>
                        </div>
                        <div className="auth-control">
                            <Switch>
                                <Route path='/login' component={LoginPage} />
                                <Route path='/signup' component={RegistrationPage} />
                                <Route path='/forgotten' component={ForgottenPage} />
                                <Route path='/resetpassword' component={PasswordResetPage} />
                                <Route path='/activate' component={ActivateAccountPage} />
                                <Route path='/resourceunavailable' component={ResourceNotAvailable} />
                                <Route path='/lost' component={PageNotFound} />
                                <Route component={PageNotFound} />
                            </Switch>
                        </div>
                    </div>
                </div>
            </React.Fragment>
    );
}

AuthLayout.propTypes =
{
    user: PropTypes.object,
    checkLogin: PropTypes.func.isRequired
}


function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    checkLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthLayout);






// WEBPACK FOOTER //
// ./src/components/common/AuthLayout.js